import * as React from 'react';
import * as styles from './styles.scss';
import { ActionButton } from '@fluentui/react/lib/Button';
import { cancelButtonText } from 'owa-locstrings/lib/strings/cancelbuttontext.locstring.json';
import { getSearchQueryString } from 'owa-timestream-search-orchestration';
import { observer } from 'mobx-react-lite';
import { SearchBox } from 'owa-search';
import { clearSearchBox, exitSearch } from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';
import { searchLabel } from 'owa-locstrings/lib/strings/searchlabel.locstring.json';
import classNames from 'classnames';
import loc from 'owa-localize';
import SearchRefiners from './searchRefiners/SearchRefiners';

export default observer(function TimestreamSearchBoxContainer() {
    const isSearching = !!getSearchQueryString();
    const cancelSearch = React.useCallback(() => {
        clearSearchBox(SearchScenarioId.Spaces);
        exitSearch('CancelSearchButton', SearchScenarioId.Spaces);
    }, []);

    return (
        <div className={styles.searchBoxContainer}>
            <div className={classNames(styles.searchBox, isSearching && styles.activeSearch)}>
                <SearchBox
                    scenarioId={SearchScenarioId.Spaces}
                    searchPlaceHolderText={loc(searchLabel)}
                    renderRefiners={createSearchRefiners}
                    disableAutoFocusWhenActivated={true}
                />
            </div>
            {isSearching && (
                <ActionButton
                    className={styles.clearSearchButton}
                    onClick={cancelSearch}
                    text={loc(cancelButtonText)}
                />
            )}
        </div>
    );
});

function createSearchRefiners() {
    return <SearchRefiners />;
}
